import type * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "border-input flex h-10 w-full min-w-0 rounded-sm border bg-background/85 px-3.5 py-2 text-sm shadow-none transition-[border-color,box-shadow,background-color] outline-none",
        "file:text-foreground file:inline-flex file:h-9 file:border-0 file:bg-transparent file:font-medium",
        "focus-visible:border-ring focus-visible:ring-ring/45 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        "placeholder:text-muted-foreground",
        "selection:bg-primary selection:text-primary-foreground ",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  );
}

export { Input };
